<div fxLayout="column">
  <mat-checkbox>{{'ACTIONS.DOUBLE' | translate}}</mat-checkbox>
  <mat-form-field>
    <mat-label>{{'ACTIONS.SOURCE' | translate}}</mat-label>
    <mat-select disableOptionCentering [(value)]="source">
      <mat-option class="mat-option-compact" *ngFor="let src of sources" [value]="src.id">{{src.title}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>